module.exports = __webpack_public_path__ + "static/media/bookmark_icon.b40790c5.svg";